import React from 'react';
import styles from './HeaderListItemListButtons.module.scss';

export const HeaderListItemListButtons = ({ label, children }: { label?: string; children: React.ReactNode }) => (
  <li>
    {label && <span className={styles.label}>{label}</span>}
    <ul className={styles.root} role="presentation">
      {children}
    </ul>
  </li>
);
